import md5 from 'md5';

import { colorScaleFn } from './colors';
import { computeComparisonLine, computeLabelValue } from './labelValues';
import { SankeyNode, SankeyRenderConfig } from './types';

export function fillInNodeColorsAndLabels(
  cfg: SankeyRenderConfig,
  nodes: SankeyNode[],
  highestNodeAmount: number
) {
  nodes.forEach((n) => {
    // Set up the label value and comparison lines for all nodes.
    n.labelValue = computeLabelValue(n, cfg, highestNodeAmount);
    n.labelComparisonLine = computeComparisonLine(n, cfg);
    // Fill in any missing Node colors. Flows may inherit from these.
    // Use the first non-blank portion of a label as the basis for adopting an already-used color or picking a new one.
    // If there are no non-blank strings in the node name, substitute a word-ish value (rather than crash)
    if (n.color === '') {
      const firstBlock = (/^\s*(\S+)/.exec(n.name) || ['', 'name-is-blank'])[1];
      n.color = colorScaleFn(firstBlock);
    }
  });
}

export const newNodeId = (name: string) => `node-${md5(name)}`;

export const newEmptyNode = (name: string): SankeyNode => ({
  amount: NaN,
  amountComparison: NaN,
  appearanceIndex: NaN,
  color: '',
  custom_amount_label: '',
  custom_comparison_label: '',
  dx: NaN,
  dy: NaN,
  flowsIn: [],
  flowsOut: [],
  id: newNodeId(name),
  labelComparisonLine: '',
  labelValue: '',
  lastPos: { x: NaN, y: NaN },
  move: [0, 0],
  name,
  origPos: { x: NaN, y: NaN },
  stage: NaN,
  totalIn: NaN,
  totalOut: NaN,
  use_custom_amount_label: false,
  use_custom_comparison_label: false,
  x: NaN,
  y: NaN,
});
